
import { save, getExam, isAward } from '@/api/chunjie'
import cookie from 'vux/src/tools/cookie/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XInput from 'vux/src/components/x-input/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { getview } from '@/api/jfhl.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XInput,
Countdown,
Group
},
data () {
return {
partyid: '1386',
isjiang: false,
subform: false,
dtnum: '',
errorti: false,
showDialog: false,
showErrorList: false,
errorList: [],
dialogText: '',
dialogType: '',
btnText: '下一题',
active: 0, // 当前题数
listlength: 0,
paperInfoid: '',
lotid: '',

examList: {},
subjectid: [],
useroption: [],
result: '', // 中奖结果,
times: 1,
show: true,
msg: '',
isshow: false,
obj: {
linkman: '',
phone: '',
randnum: '',
address: ''
},
countdown: {
time: 45,
value: '发送',
start: false
},
lottery: true,
a: true,
guize: false,
answertext: [],
isclick: true
}
},
mounted () {





this.view()
},
created () { },
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
methods: {

view () {
getview({
id: this.partyid
}).then(res => {
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.isAwardNow()
this.getExamNow()
})
},
onblur (val, $event) {
window.scroll(0, 0)
document.activeElement.scrollIntoViewIfNeeded(true)
},
formshow () {
this.showDialog = false
this.$router.push({ name: 'chunjie_lottery' })
},
again () {
window.location.reload()
},
viewerrorlist () {
this.showErrorList = true
},

answer () {
let _this = this
if (this.active + 1 >= this.examList.length) {
console.log(this.subjectid)
console.log(this.useroption)
if (!this.useroption[this.active]) {
this.$vux.toast.text('请填写答案')
return false
}
if (_this.isclick) {
_this.isclick = false
save({
paperInfoid: this.paperInfoid,
subjectid: this.subjectid.join(';'),
useroption: this.useroption.join(';'),
openid: this.accountid
}).then(data => {
if (data.obj.ISTRUE == 1) {
this.showDialog = true

this.dialogType = 'success'
this.dialogText = '好棒，您全都答对了'
} else {
this.dtnum = data.obj.ANSWERNUM
this.errorti = true
let wt = data.obj.ERRORLIST.length
this.dialogText =
'答对' + (this.examList.length - wt) + '题，答错' + wt + '题'
this.errorList = data.obj.ERRORLIST
this.dialogType = 'fail'
}
this.subjectid = []
this.useroption = []
setTimeout(() => {
_this.isclick = true
}, 3000)
})
}
} else {
if (!this.useroption[this.active]) {
this.$vux.toast.text('请填写答案')
return false
}
this.active++
}
},
getExamNow () {
let _this = this
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.$vux.alert.show({
content: '您今天的答题机会已用完<br>请明天再来',
onHide () {
_this.$router.go(-1)
}
})
return false
}
this.examList = data.obj.SUBJECTLIST
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
this.listlength = data.obj.SUBJECTLIST.length
console.log('www', this.subjectid)
})
},

isAwardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.iszhongjiang == 1) {
this.isjiang = true
} else {
this.isjiang = false
}
}
)
},
reload () {
window.location.reload()
}
},
watch: {
active (newVaule, oldValue) {
if (newVaule == this.listlength - 1) {
this.btnText = '提交'
}
},
isshow () { }
}
}
